import { Grid, InputAdornment } from "@material-ui/core";
import React from "react";

import { Form } from "../../../../components/form";
import { FormButton } from "../../../../components/form_button";
import { TextInput } from "../../../../components/text_input";
import { IFormProps } from "../../../../core/models";
import { isPending } from "../../../../core/redux";
import { budgetFormValidation, IBudgetForm } from "../../data/entities";

interface IProps extends IFormProps<IBudgetForm> {}

export const BudgetForm: React.FC<IProps> = (props: IProps) => {
  const { branch, submitTitle } = props;
  const loading = isPending(branch);

  return (
    <Grid container justify="center">
      <Grid item md={8} lg={6}>
        <Form<IBudgetForm>
          {...props}
          initialValues={{
            amount: 0,
          }}
          validationSchema={budgetFormValidation}
        >
          {() => (
            <>
              <TextInput
                label="Məbləğ"
                name="amount"
                type="number"
                InputProps={{
                  startAdornment: <InputAdornment position="start">AZN</InputAdornment>,
                }}
              />

              <FormButton label={submitTitle} loading={loading} />
            </>
          )}
        </Form>
      </Grid>
    </Grid>
  );
};
